import * as tslib_1 from "tslib";
import { Api } from '../api/api';
import { environment } from '../environment';
import { ESRI } from '../esri-loader-util';
import { LogLevel } from '../types';
import { ToSqlStringService } from './to-sql-string.service';
import * as i0 from "@angular/core";
import * as i1 from "../api/api";
import * as i2 from "./to-sql-string.service";
var Geoprocessor;
var ExportService = /** @class */ (function () {
    function ExportService(api, toSqlStringService, loggingService) {
        this.api = api;
        this.toSqlStringService = toSqlStringService;
        this.loggingService = loggingService;
    }
    ExportService.prototype.exportToShapeFileAndOpenUrl = function (exportParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.exportToShapeFile(exportParams)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            window.open(result.value.url, '_blank');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ExportService.prototype.exportToShapeFile = function (exportParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params, url, gp, jobInfo;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            Table: exportParams.tables ? exportParams.tables.map(function (t) { return t.owner + "." + t.name; }).join(',') : 'SKIP',
                            Filter: this.toSqlStringService.getSql(exportParams.query, exportParams.columns),
                            Output_name: exportParams.name.replace(/[\\*/:<>?|\"%]/gi, ' '),
                            Geometries: exportParams.geometries ? exportParams.geometries : ''
                        };
                        if (!!Geoprocessor) return [3 /*break*/, 2];
                        return [4 /*yield*/, ESRI.Geoprocessor];
                    case 1:
                        Geoprocessor = _a.sent();
                        _a.label = 2;
                    case 2:
                        url = environment.ags.baseUrl + environment.ags.exportEndpoint;
                        gp = new Geoprocessor({ url: url });
                        return [4 /*yield*/, gp.submitJob(params)];
                    case 3:
                        jobInfo = _a.sent();
                        if (jobInfo.jobStatus === 'job-failed') {
                            this.loggingService.Log('export shapefile job failed', jobInfo.messages, LogLevel.Error);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, gp.waitForJobCompletion(jobInfo.jobId)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, gp.getResultData(jobInfo.jobId, 'Output_File_Path')];
                }
            });
        });
    };
    ExportService.prototype.exportToExcelAndOpenUrl = function (exportParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fileUrl;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.exportToExcel(exportParams)];
                    case 1:
                        fileUrl = _a.sent();
                        window.open(fileUrl, '_blank');
                        return [2 /*return*/];
                }
            });
        });
    };
    ExportService.prototype.exportToExcel = function (exportParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filename;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.post('export/excel', exportParams, { responseType: 'text' })];
                    case 1:
                        filename = _a.sent();
                        return [2 /*return*/, [this.api.http2.url, 'export/file/', filename].join('')];
                }
            });
        });
    };
    ExportService.ngInjectableDef = i0.defineInjectable({ factory: function ExportService_Factory() { return new ExportService(i0.inject(i1.Api), i0.inject(i2.ToSqlStringService), i0.inject("LoggingService")); }, token: ExportService, providedIn: "root" });
    return ExportService;
}());
export { ExportService };
